export default "__VITE_ASSET__CfS5JMcq__"